module.exports = __webpack_public_path__ + "static/media/statistics.99472f6c.png";